var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.73 17.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.51,15.05c-.06.1-.11.18-.15.26l-1,1.79a.64.64,0,0,1-.89.32L6.05,14.66a.58.58,0,0,1-.31-.88c.4-.77.81-1.53,1.21-2.29A.89.89,0,0,1,7.46,11l3.1-1h.07l.65.76-2.66.85.17.09,5.57,2.11a.42.42,0,0,0,.27,0l5.61-2.13.16-.07-2.69-.87c.21-.26.4-.5.6-.73a.18.18,0,0,1,.16,0c1.05.32,2.09.64,3.12,1a.8.8,0,0,1,.42.37c.45.79.87,1.6,1.28,2.41a.58.58,0,0,1-.33.85l-2.38,1-3.9,1.67a1.26,1.26,0,0,1-.33.1.62.62,0,0,1-.68-.34l-1.05-1.88C14.59,15.19,14.55,15.13,14.51,15.05Z",
    transform: "translate(-5.64 -5.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.51,6.5a2.38,2.38,0,0,1,1.16-.64,2.29,2.29,0,0,1,2.65,1.66,1.31,1.31,0,0,1-.12.93,8.66,8.66,0,0,1-.74,1.15,17.54,17.54,0,0,1-2.65,2.59.45.45,0,0,1-.61,0,17,17,0,0,1-2.88-2.87,4.56,4.56,0,0,1-.38-.59,1.85,1.85,0,0,1,.54-2.48,2.26,2.26,0,0,1,2.7,0Z",
    transform: "translate(-5.64 -5.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.94,23.18v-5.4l.12.1a1.55,1.55,0,0,0,1.79.38c1.09-.44,2.17-.92,3.25-1.38l1.75-.75a1.76,1.76,0,0,1,0,.19V20.2a.6.6,0,0,1-.48.67L15.1,23.14A.53.53,0,0,1,14.94,23.18Z",
    transform: "translate(-5.64 -5.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.14,16.13l1.5.63L12,18.21a1.61,1.61,0,0,0,2-.37l.07-.06v5.41l-.88-.31-5.53-2a.63.63,0,0,1-.51-.73Z",
    transform: "translate(-5.64 -5.81)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.21c1b138f8d7de7c4d2d49950dda4230.svg";
export { ForwardRef as ReactComponent };